import { useEffect } from 'react';
import { REDIRECT_URL } from 'app/shared/util/url-utils';
import { useLocation } from 'react-router';

export const LoginRedirect = () => {
  const pageLocation = useLocation();

  useEffect(() => {
    // OAuth 콜백 후 서버 리다이렉트로 /sign-in에 도착하면 location.state가 없음
    let fromPath = pageLocation.state?.from?.pathname ?? (pageLocation.pathname || '/');
    // /sign-in 저장 시 Home에서 /sign-in으로 리다이렉트 → 무한 루프 발생
    if (fromPath === '/sign-in' || fromPath.startsWith('/sign-in/')) {
      fromPath = '/';
    }
    localStorage.setItem(REDIRECT_URL, fromPath);
    window.location.href = '/oauth2/authorization/oidc';
  });

  return null;
};

export default LoginRedirect;
